import { render, staticRenderFns } from "./CustomerGoodsAliasTable.vue?vue&type=template&id=648c46c4&scoped=true&"
import script from "./CustomerGoodsAliasTable.vue?vue&type=script&lang=ts&"
export * from "./CustomerGoodsAliasTable.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerGoodsAliasTable.vue?vue&type=style&index=0&id=648c46c4&scoped=true&lang=css&"
import style1 from "./CustomerGoodsAliasTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648c46c4",
  null
  
)

export default component.exports